export const errorMessages = {
  firstName: "The name must be more than 2 characters",
  secondName: "",
  country: "Fill in the field",
  phone: "Fill in the field",
  password: "Password must have 1 letter, 1 number and one symbol",
  confirmPassword: "Password does not match",
  email: "Email is not correct",
};
